import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { connect } from 'react-redux';
import axios from 'axios';
import { kinetik_api_url } from '../utilities/const';
import 'react-datepicker/dist/react-datepicker.css';
import BillingCreditCardModal from './billingCreditCardModal';
import { cardInformations } from '../actions/settings_companyProfile.action';

//var fileDownload = require('react-file-download');

class BillingPage extends Component {

    constructor(){
        super();
        this.state = {
            startDate: moment(),
            endDate: moment(),
            hideOrShowCreditCardModal: false,
            cardName: '',
            cardNumber: '',
            claimsAdded: false,
            claimsBreakdown: {},
            payerUniqueList: [],
            totalClaims: 0,
            currentBalance: 0,
            nextBillingDate: moment(),
            isPaymentsFetched: false,
            paymentHistories: {}
        }
    }

    componentDidMount() {
        let URL = `${kinetik_api_url}/getBilling?token=${localStorage.getItem('authToken')}`;
        let claimsURL = `${kinetik_api_url}/claimsBreakDown?token=${localStorage.getItem('authToken')}`;
        let getPaymentsHistory = `${kinetik_api_url}/getPayments?token=${localStorage.getItem('authToken')}`;

        axios.get(URL)
        .then( (res) => {
            console.log("card info",res)
            this.setState({
                cardNumber: res.data.card_number,
                cardName: `${res.data.first_name} ${res.data.last_name}`
            });

            this.props.cardInformations(res.data);
        })
        .catch( (error) => {
            console.log(error);
        });

        axios.get(claimsURL)
        .then( (res) => {
            console.log("claimsBreakdown",res)
            this.setState({
                claimsAdded: true,
                claimsBreakdown: res.data.breakdown,
                payerUniqueList: res.data.payerUniqueList,
                totalClaims: res.data.totalClaims,
                currentBalance: res.data.currentBalance,
                nextBillingDate: res.data.nextBillingDate !== "" && res.data.nextBillingDate ? res.data.nextBillingDate : moment()
            });
        })
        .catch( (error) => {
            console.log(error);
        })

        axios.get(getPaymentsHistory)
        .then( (res) => {
            console.log("payment history",res)
            this.setState({
                isPaymentsFetched: true,
                paymentHistories: res.data
            });
        })
        .catch( (error) => {
            console.log('Error on Fetching Payment History',error);
        })
    }

    handleChange = (date) => {
        this.setState({
        startDate: date
        });
        this.updatePaymentHistory(date, this.state.endDate);
    }
    handleChangeEnd = (date) => {
        this.setState({
        endDate: date
        });
        this.updatePaymentHistory(this.state.startDate, date);
    }

    updatePaymentHistory = (startDate, endDate) => {
        let getPaymentsHistory = `${kinetik_api_url}/getPayments?token=${localStorage.getItem('authToken')}&fromDate=${startDate}&toDate=${endDate}`;
        
        axios.get(getPaymentsHistory)
        .then((res) => {
            console.log("payment history with date",res)
            this.setState({
                isPaymentsFetched: true,
                paymentHistories: res.data
            });
        })
        .catch((error) => {
            console.log('Error on Fetching Payment History', error);
        })
    }

    hideOrShowCreditCardModalF = () => {
        this.setState({
            hideOrShowCreditCardModal: this.state.hideOrShowCreditCardModal ? false : true
        });
    }

    handleCreditCardForm = (data) => {
        this.setState({
            hideOrShowCreditCardModal: true
        })
    }

    // downloadInvoice = (invoice_number) => {
    //     let token = localStorage.getItem('authToken');

    //     if(token) {
    //         let URL = `${kinetik_api_url}/generate_pdf?token=${token}&invoice_number=${invoice_number}`;

    //         axios.get(URL)
    //         .then (downloadedInvoice => {
    //             fileDownload(downloadedInvoice.data, 'Invoice.pdf');
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         })
    //     }
    // }
    render () {

        let breakdowns;
        if(this.state.claimsAdded) {
            breakdowns = this.state.payerUniqueList.map((v, k) => {
                let breakdown = this.state.claimsBreakdown;

                return (
                    <div className="bal_det_item" key={k}>
                        <p className="left_bal_item">{v}</p>
                        <p className="right_bal_item">{breakdown[v]}</p>
                    </div>
                )
            });
        }
        let paymentHistories;
        if (this.state.isPaymentsFetched) {
            paymentHistories = this.state.paymentHistories.map((v, k) => {
                let createdDate = moment(v.created_date).format('MMM DD, YYYY');
                let token = localStorage.getItem('authToken');
                let URL = `${kinetik_api_url}/generate_pdf?token=${token}&invoice_number=${v.invoice_number}`;
                return (
                    <tr className="tr_r_p_table" key={k}>
                        <td>{createdDate}</td>
                        <td>{v.invoice_number}</td>
                        <td className="fx_ad_pd_bal">${v.invoice_amount}</td>
                        <td> <a target="blank" href={URL} className="inv_ta_dl_btn"> PDF </a></td>
                    </tr>
                )
            });
        }
        return (
            <div>
                <div className="row fx_mar_bill_d">
                    <div className="col-md-4">
                            <div className="brd_tab_cntnt vendor__">
                                <h4 className="vendor_h_title">Account Balance</h4>
                                <div className="bal_summ_l">
                                    <p className="left_bal_sm">Current Account Balance</p>
                                    <p className="right_bal_sm">${this.state.currentBalance}</p>
                                </div> <br />
                                <div className="week_of_mnth">
                                <p>Week of {moment(this.state.nextBillingDate).format('MMM DD, YYYY')}</p>
                                </div>
                            </div>

                    </div>
                    <div className="col-md-4">
                        <div className="brd_tab_cntnt vendor__">
                            <h4 className="vendor_h_title">Balance Details</h4>
                        </div>
                        {breakdowns && (
                            <div className="bal_dt_body">
                                <div className="bal_det_item h_bal_dt">
                                    <p className="left_bal_item">Payer</p>
                                    <p className="right_bal_item"># Claims of Submitted</p>
                                </div>
                                {breakdowns}
                                <div className="bal_det_item f_bal_dt">
                                    <p className="left_bal_item">Total Claims</p>
                                    <p className="right_bal_item">{this.state.totalClaims}</p>
                                </div>
                            </div>
                        )}

                    </div>
                    <div className="col-md-4">
                        <div className="brd_tab_cntnt vendor__ fx_dsptch">
                            <h4 className="vendor_h_title">Payment Method</h4>
                            <div className="payment_m_cntnt">
                                <span className="payment_m_name">{this.props.billingData.customer_id ? `${this.props.billingData.first_name} ${this.props.billingData.last_name}` : `N/A`}</span>
                                <div className="row fx_margin_pmnt">
                                    <b className="c_id_name">
                                        {this.props.billingData.customer_id ? `${this.props.billingData.card_number}` : `N/A`}
                                    </b>
                                    <input onClick={this.handleCreditCardForm} type="submit" value={this.props.billingData.card_number ? `Update` : `Add`} id="update_add_c_btn" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row fx_pmnt_hst_table">
                    <div className="col-md-2"></div>
                    <div className="col-md-6">
                        <div className="payment_historyTable">
                            <div className="row">
                                <div className="col align-self-start">
                                    <h4 className="vendor_h_title">Payments History</h4>
                                </div>
                                <div className="col align-self-endss">
                                    <div className="form-inline">
                                        <div className="form-group mb-2">
                                            <i className="calendar_ic_p_hist_t fa fa-calendar"></i>
                                        </div>
                                        <div className="form-group mb-2">
                                            <DatePicker
                                                selected={this.state.startDate}
                                                onChange={this.handleChange}
                                                className="d_picker_hist_tab"
                                            />
                                        </div>
                                        <div className="form-group mb-3">
                                            <p className="separator_cls_slctor">
                                                --
                                        </p>
                                        </div>
                                        <div className="form-group mb-2">
                                            <DatePicker
                                                selected={this.state.endDate}
                                                onChange={this.handleChangeEnd}
                                                className="d_picker_hist_tab"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="users_on_settings">
                                {this.state.paymentHistories.length !== 0 ? (
                                    <table className="user_settin_ta p_hist_ta__">
                                        <thead>
                                            <tr className="tr_r_p_table">
                                                <th>Date</th>
                                                <th>Invoice Number</th>
                                                <th>Invoice Amount</th>
                                                <th>Download</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paymentHistories}
                                        </tbody>
                                    </table>
                                ) : (<b className="no_hst_fnd_msg">No Payment History Available</b>)}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3"></div>
                </div>

                <BillingCreditCardModal
                    show={this.state.hideOrShowCreditCardModal}
                    hideOrShowEditingModal={this.hideOrShowCreditCardModalF}
                    userData={"this.state.editingUserData"}
                />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    billingData: state.billingData,
})

export default connect(mapStateToProps, { cardInformations })(BillingPage)


// WEBPACK FOOTER //
// ./src/app/profile_settings/BillingPage.js